import MainSliderContent from './MainSliderContent';
import ResponsiveSliderImage from './ResponsiveSliderImage';
import type { MainSliderItem } from './types';
import { cn, getButtons } from './utils';

interface SplitSlideProps {
  slide: MainSliderItem;
}

const SplitSlide = ({ slide }: SplitSlideProps) => {
  const imagePosition = slide.imagePosition ?? 'left';
  const isImageRight = imagePosition === 'right';
  const buttons = getButtons(slide.buttons, slide.button);

  const imageFitClass =
    slide.imageFit === 'contain' ? 'object-contain' : 'object-cover';

  return (
    <div
      className={cn(
        'tablet:p-8 h-full overflow-hidden rounded-2xl p-4 shadow-sm',
        slide.slideClassName,
      )}
    >
      <div
        className={cn(
          'laptop:grid-cols-2 grid h-full grid-cols-1 items-center gap-8',
          isImageRight && 'laptop:[&>*:first-child]:order-2',
          slide.innerClassName,
        )}
      >
        <ResponsiveSliderImage
          imagePath={slide.imagePath}
          mobileImagePath={slide.mobileImagePath}
          imageAlt={slide.imageAlt}
          className="relative h-full min-h-[280px] w-full"
          imageClassName={cn(imageFitClass, slide.imageClassName)}
          priority
        />

        <div className="tablet:px-8 h-full px-2">
          <MainSliderContent
            content={slide.content}
            buttons={buttons}
            textPosition={slide.textPosition ?? 'center'}
            className={slide.contentClassName}
            richTextStyles={slide.richTextStyles}
            buttonClassName={slide.buttonClassName}
            buttonsClassName={slide.buttonsClassName}
            buttonAlignment={slide.buttonAlignment} // Add this
          />
        </div>
      </div>
    </div>
  );
};

export default SplitSlide;
